import modal from '@/utils/modal';
import callApi from '@/utils/callApi';
import OpenLootCrateModal from './OpenLootCrateModal.vue';

export default async function openLootCrate(lootCrate) {
  if (! lootCrate || ! lootCrate.typeName) {
    console.error('No loot crate provided');
    return;
  }

  const res = await callApi('POST', `/v1/client/types/my-loot-crates/${lootCrate.typeName}/open`);

  if (res.status === 401) {
    return {
      success: false,
      error: 'session_expired',
    };
  } else if (res.status !== 200) {
    return {
      success: false,
      error: 'crate_not_found',
    };
  }

  const resBody = await res.json();
  const contents = resBody.contents || [];
        
  modal.create(OpenLootCrateModal, true, {
    disableCloseButton: true, 
    provide: {
      lootCrate,
      contents,
    },
  });

  return {
    success: true,
  };
}